/** Gatsby develop webpack chunk for `src/pages/message.js`. */
const MESSAGE_PAGE_DEV_CHUNK = '/component---src-pages-message-js.js'

let messagePageWarmStarted = false

/**
 * Warm the CRM message thread page (+ PageMessage app) before sidebar clicks.
 * Develop compiles are multi‑second; without this, chat clicks look dead while
 * webpack builds the chunk and the main thread stays busy.
 *
 * Delay the develop compile poke so we don't compete with the dashboard chunk
 * on first paint (both hitting webpack at once is what causes chunk timeouts).
 */
export function prefetchMessagePage({ immediate = false } = {}) {
  if (typeof window === 'undefined') return

  try {
    window.___loader?.enqueue?.('/message/')
  } catch {
    // Prefetch is best-effort.
  }

  if (process.env.NODE_ENV !== 'development' || messagePageWarmStarted) {
    return
  }

  const startWarm = () => {
    if (messagePageWarmStarted) return
    messagePageWarmStarted = true
    fetch(MESSAGE_PAGE_DEV_CHUNK, { priority: 'low' }).catch(() => {})
    void import('../components/PageMessage').catch(() => {})
  }

  if (immediate) {
    startWarm()
  } else {
    window.setTimeout(startWarm, 4000)
  }
}
